export const mockCoverageTypeOptions = {
  label: 'Medical',
  prop: 'medical',
};
